var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('div',{style:({position: 'absolute', top:'0', right:0})},[_c('dark-mode')],1),_c('gallery-menu',{attrs:{"nav":_vm.menu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }